import React from 'react';
import TextSlice from './TextSlice';
import FullWidthImageSlice from './FullWidthImageSlice';
import TextSlider from './TextSlider';
import TextBackgroundSlice from './TextBackgroundSlice';
import PhotoSection from './PhotoSection';
import LogoSection from './LogoSection';
import ProductFeatureSlice from './ProductFeatureSlice';
import ProductGallerySlice from './ProductGallerySlice';
import BenefitFeatureSlice from './BenefitFeatureSlice';
import ColumnSlice from './ColumnSlice';
import StrainFinderSlice from './StrainFinderSlice';
import StandardHero from './StandardHero';
import SpecialHero from './SpecialHero';
import VideoSlice from './VideoSlice';
import FAQSlice from './FAQSlice';
import PDFSection from './PDFSection';
import SpecialImageContent from './SpecialImageContent';
import CTASlice from './CTASlice';
import VideoHero from './VideoHero';
import SpecialHeroV2 from './SpecialHeroV2';
import TerpenesFeatureSlice from './TerpenesFeatureSlice';
import TerpeneFinderSlice from './TerpeneFinderSlice';
import BlogSlice from './BlogSlice';
import HeroHalfImgContent from './HeroHalfImgAndContent';
import FactSlice from './FactSlice';
import PartnerSlice from './PartnerSlice';
import VideoThumbSlice from './VideoThumbSlice';
import ImageCopyBlocks from './ImageCopyBlocks';
import LLRChartSlice from './LLRChartSlice';
import LLRCustomHero from './LLRCustomHero';
import YoutubeSlice from './YoutubeSlice';

export default function Slices(props) {
  if (!document) {
    return null;
  }
  return (
    <div className="slice-wrapper">
      {props.slices.map((slice, index) => (
        <div
          key={index}
          className={`slice-single ${
            slice.type === slice.full_width_text_image_slice && slice.primary.half_width
              ? 'half-width'
              : 'full-width'
          }`}>
          {slice.slice_type === 'product_gallery_slice' && ProductGallerySlice(slice)}
          {slice.slice_type === 'column_slice' && ColumnSlice(slice)}
          {slice.slice_type === 'text_slice' && TextSlice(slice)}
          {slice.slice_type === 'text_slider' && TextSlider(slice)}
          {slice.slice_type === 'faq_slice' && FAQSlice(slice)}

          {slice.slice_type === 'full_width_image_slice' && FullWidthImageSlice(slice)}
          {slice.slice_type === 'questions_slice' && TextSlider(slice)}
          {(slice.slice_type === 'full_width_text_image_slice' ||
            slice.slice_type === 'background_image_text_slice') &&
            TextBackgroundSlice(slice)}
          {(slice.slice_type === 'photo_section' || slice.slice_type === 'image_content_section') &&
            PhotoSection(slice)}
          {slice.slice_type === 'logo_section' && LogoSection(slice)}
          {slice.slice_type === 'product_feature_slice' && ProductFeatureSlice(slice)}
          {slice.slice_type === 'benefit_feature_slice' && BenefitFeatureSlice(slice)}
          {slice.slice_type === 'strain_finder_slice' && StrainFinderSlice(slice)}
          {slice.slice_type === 'standard_hero' && StandardHero(slice)}
          {slice.slice_type === 'special_hero' && SpecialHero(slice)}
          {slice.slice_type === 'video_embed_slice' && VideoSlice(slice)}
          {slice.slice_type === 'pdf_section' && PDFSection(slice)}
          {slice.slice_type === 'special_image_content' && SpecialImageContent(slice)}
          {slice.slice_type === 'cta_slice' && CTASlice(slice)}
          {slice.slice_type === 'video_hero' && VideoHero(slice)}
          {slice.slice_type === 'special_hero_v2' && SpecialHeroV2(slice)}
          {slice.slice_type === 'terpenes_feature_slice' && TerpenesFeatureSlice(slice)}
          {slice.slice_type === 'terpene_finder_slice' && TerpeneFinderSlice(slice)}
          {slice.slice_type === 'blog_slice' && BlogSlice(slice)}
          {slice.slice_type === 'hero_half_image_half_content' && HeroHalfImgContent(slice)}
          {slice.slice_type === 'fact_slice' && FactSlice(slice)}
          {slice.slice_type === 'partner_slice' && PartnerSlice(slice)}
          {slice.slice_type === 'video_thumb_slice' && VideoThumbSlice(slice)}
          {slice.slice_type === 'image_copy_blocks' && ImageCopyBlocks(slice)}
          {slice.slice_type === 'llr_chart_slice' && LLRChartSlice(slice)}
          {slice.slice_type === 'llr_custom_hero' && LLRCustomHero(slice)}
          {slice.slice_type === 'youtube_slice' && YoutubeSlice(slice)}
        </div>
      ))}
    </div>
  );
}
